import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "logo"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "pitem"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_menu_item = _resolveComponent("el-menu-item");
  const _component_el_menu = _resolveComponent("el-menu");
  const _component_ArrowDownBold = _resolveComponent("ArrowDownBold");
  const _component_el_row = _resolveComponent("el-row");
  const _component_router_link = _resolveComponent("router-link");
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
  const _component_el_dropdown = _resolveComponent("el-dropdown");
  return _openBlock(), _createBlock(_component_el_row, {
    class: "menuBox"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
      class: "logoImg",
      src: _ctx.website && _ctx.website.site_logo || ''
    }, null, 8, _hoisted_2)]), _createVNode(_component_el_menu, {
      "active-text-color": "#edc890",
      "background-color": "#18191d",
      class: "navBar",
      "default-active": $props.navBarActiveUrl,
      mode: "horizontal",
      router: true,
      "text-color": "#a18662"
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.navBarList, (item, itemIndex) => {
        return _openBlock(), _createElementBlock("div", {
          key: item.path
        }, [item.meta.display != 'none' && item.meta.hidden != true ? (_openBlock(), _createBlock(_component_el_menu_item, {
          key: 0,
          index: item.path,
          onClick: $event => $setup.clickNavBar(itemIndex, item.path)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(item.meta.icon)))]),
            _: 2
          }, 1024), _createTextVNode(" " + _toDisplayString(item.meta.title), 1)]),
          _: 2
        }, 1032, ["index", "onClick"])) : _createCommentVNode("", true)]);
      }), 128))]),
      _: 1
    }, 8, ["default-active"]), _createElementVNode("div", {
      class: "deployManage",
      onClick: _cache[0] || (_cache[0] = (...args) => $setup.goDeployManage && $setup.goDeployManage(...args))
    }, " 独立部署管理 "), _createVNode(_component_el_row, {
      align: "middle",
      class: "userInfo"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_dropdown, null, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [_createVNode(_component_el_dropdown_item, null, {
            default: _withCtx(() => [_createVNode(_component_router_link, {
              to: "/other/modifyPwd"
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode("修改密码", -1)]))]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_dropdown_item, null, {
            default: _withCtx(() => [_createElementVNode("a", {
              onClick: _cache[1] || (_cache[1] = (...args) => $setup.logoutM && $setup.logoutM(...args))
            }, "退出登录")]),
            _: 1
          })]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_row, {
          align: "middle",
          style: {
            "color": "#a18662",
            "cursor": "pointer"
          }
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", null, _toDisplayString(_ctx.userInfo.nickname ? _ctx.userInfo.nickname : _ctx.userInfo.mobile), 1), _createVNode(_component_el_icon, {
            class: "icon"
          }, {
            default: _withCtx(() => [_createVNode(_component_ArrowDownBold)]),
            _: 1
          })])]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  });
}